const STORAGE_KEY = 'shiptanbul-legal-update-notice'

/** Bump when terms/privacy change so users see the notice again. */
export const LEGAL_NOTICE_VERSION = '1'

interface LegalUpdateNoticeAck {
  version: string
  timestamp: number
}

export const isLegalUpdateNoticeAcknowledged = (): boolean => {
  if (typeof window === 'undefined') return true
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return false
    const parsed = JSON.parse(raw) as LegalUpdateNoticeAck
    return parsed.version === LEGAL_NOTICE_VERSION
  } catch {
    return false
  }
}

export const acknowledgeLegalUpdateNotice = (): void => {
  if (typeof window === 'undefined') return
  const payload: LegalUpdateNoticeAck = {
    version: LEGAL_NOTICE_VERSION,
    timestamp: Date.now(),
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch {
    // localStorage may be disabled
  }
}
